import React from 'react';
import { Link } from 'react-router-dom';
import { paths } from '../routes/paths';
import './LibroReclamacionesBadge.css';

export default function LibroReclamacionesBadge({ className = '' }) {
  return (
    <Link
      to={paths.libroReclamaciones}
      className={`lr_badge ${className}`.trim()}
      aria-label="Libro de Reclamaciones virtual"
    >
      <span className="lr_badge_icon" aria-hidden="true">
        <svg viewBox="0 0 48 40" width="42" height="34">
          <path
            fill="#fff"
            d="M24 6c-3.2-2.2-7.4-3.4-12.2-3.4H6v30.2h6.2c4.6 0 8.6 1.1 11.8 3.2 3.2-2.1 7.2-3.2 11.8-3.2H42V2.6h-5.8C31.4 2.6 27.2 3.8 24 6z"
          />
          <path
            fill="#9b1c1c"
            d="M24 8.2c-3-1.8-6.8-2.8-11.4-2.8H8.4v24.8h4.4c4.2 0 8 1 11.2 2.8 3.2-1.8 7-2.8 11.2-2.8h4.4V5.4h-4.2c-4.6 0-8.4 1-11.4 2.8z"
          />
          <path fill="#fff" opacity="0.35" d="M23.2 6.8h1.6v27.2h-1.6z" />
        </svg>
      </span>
      <span className="lr_badge_text">Libro de Reclamaciones</span>
    </Link>
  );
}
